const ESCAPED_CHARS: { [key: string]: string } = {
	'<': '\\u003C',
	'>': '\\u003E',
	'/': '\\u002F',
	'\u2028': '\\u2028',
	'\u2029': '\\u2029',
};

const UNSAFE_CHARS_REGEXP_EXCLUDE_QUOTES = /[<>\/\u2028\u2029]/g;

/**
 * Put output directly in a script tag.
 */
export function stringifyForSSR(data: any): string {
	// JSON.stringify(undefined) returns undefined, so we need to handle it separately
	// JSON.stringify(null) returns 'null'
	if (data === undefined) {
		return String(data);
	}
	return JSON.stringify(data).replace(
		UNSAFE_CHARS_REGEXP_EXCLUDE_QUOTES,
		(char) => ESCAPED_CHARS[char],
	);
}
